import "layouts/Home/Home.css";
import React from "react";
import pagesStyle from "../../../assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import {Link} from "react-router-dom";
import FreshChat from "../../../utils/FreshChat";
import localization from "../../../config/localization";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {Facebook, Instagram, Youtube} from "../../../components/Letflow/SocialIcons";
import styled from "styled-components";
import {clientIsTypeCatalog, GAevent, getRefreshToken} from "../../../api-client/core/authentication/utils";
import {addHttpToUrl} from "../../../utils";
import {getSocialLinkIcon} from "../../../components/Letflow/SocialLinks";
import {Close, Email, Help} from "@material-ui/icons";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {Dialog, DialogActions, DialogContent, IconButton} from "@material-ui/core";
import Button from "../../../components/CustomButtons/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import CustomInput from "../../../components/CustomInput/CustomInput";
import {request} from "../../../api-client";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import TectomediaWhite from "../../../assets/img/Letflow/Logos/TecToMedia-white.png";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideMenu: "close",
      height: "0%",
      showHelpDialog: false,
      submiting: false,
      name: '',
      email: '',
      query: ''
    };
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function () {
        this.setState({cardAnimation: ""});
      }.bind(this),
      700
    )
  }

  sendHelp = () => {
    if(this.state.name && this.state.email && this.state.query && this.props.channel) {
      this.setState({submitting:true})
      GAevent('Usuario', "Soporte", "")

      request.channel.help(this.props.channel.id, this.state.name, this.state.email, this.state.query)
        .then(() => this.setState({name: '', email: '',query: '',showHelpDialog: false, submitting: false},
          () =>  GlobalSnackbar.show({
            message: localization.get('send_successfully'),
            type: GlobalSnackbarTypes.SUCCESS,
          })))
    }else {
      GlobalSnackbar.show({
        message: localization.get('complete data'),
        type: GlobalSnackbarTypes.ERROR,
      })
    }
  }

  render() {
    return (
      <footer style={{padding: this.props.loginChannel ? "15px 0px" : 0, position: this.props.modalFooter && 'fixed' }}>
        <Dialog open={this.state.showHelpDialog} onBackdropClick={() => this.setState({showHelpDialog: false})} onEscapeKeyDown={() => this.setState({showHelpDialog: false})}>
          <DialogContent style={{ width: "100%" }}>
            <h3 style={{fontSize: '1.3125rem', fontWeight: 500, color: '#000000de'}}>{localization.get('channel.support')}</h3>

            <p style={{ color: '#000000de'}}>{localization.get('channel.support_text')}</p>
            <CustomInput
              labelText="Nombre completo"
              id="name"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: e => this.setState({ name: e.target.value })
              }}
            />
            <CustomInput
              labelText="Email"
              id="email"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: e => this.setState({ email: e.target.value })
              }}
            />
            <CustomInput
              labelText="Consulta"
              id="query"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: e => this.setState({ query: e.target.value })
              }}
            />
          </DialogContent>
          <DialogActions style={{margin: "0 4% 4%"}}>
            <Button onClick={this.sendHelp} color='default' style={{ backgroundColor: "black" }} disabled={this.state.submitting}>
              {localization.get("send")}
            </Button>
          </DialogActions>
        </Dialog>
        {/*<div className="footer-top">
          <div className="container">
            <div className="row-footer">
              <div className="text-left">
                <img src={logo} alt="Logo flowlike" />
                <p style={{ color: "#777", fontSize: "11px" }}>
                  {localization.get('footer.description')}
                </p>
              </div>
              <div className="text-right footer-menu">
                <ul className="nowrap">
                  <li>
                    <Link to={"#"} onClick={(e) => {
                      e.preventDefault()
                      FreshChat.open()
                    }}>
                      <span className="link-footer">{localization.get("footer.support")}</span>
                    </Link>
                  </li>
                  <li>
                    <Tooltip title="Youtube" placement="bottom">
                      <Link className="footer-social-link" target="_blank" to="https://www.youtube.com/c/FlowlikeMusic/">
                        <Youtube />
                      </Link>
                    </Tooltip>
                    <Tooltip title="Facebook" placement="bottom">
                      <Link className="footer-social-link" target="_blank" to="https://www.facebook.com/Flowlikemusic/">
                        <Facebook />
                      </Link>
                    </Tooltip>
                    <Tooltip title="Instagram" placement="bottom">
                      <Link
                        className="footer-social-link"
                        target="_blank"
                        to="https://www.instagram.com/flowlikemusic/"
                      >
                        <Instagram />
                      </Link>
                    </Tooltip>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>*/}
        <div className="footer-bottom" style={{animation: this.props.channel && "ease-in 1s", bottom: this.props.loginChannel ? (this.props.activeChannel ? -25 : -15 ): 0}}>
          <div className="container-footer">
            <div className="row-footer-bottom">
              <MobileDiv>
                {/*{!!this.props.channel && !!this.props.channel.bloomcloud_channel &&*/}
                {/*  <h6 style={{ marginRight: 20}}>*/}
                {/*    <small>© 2019 Bloomclouds</small>*/}
                {/*  </h6>*/}
                {/*}*/}
                <FooterDocumentLink
                  requestRoute={`${process.env.REACT_APP_API_HOST}/documents/privacyPolicy/download?locale=${localization.getLanguage()}`}
                  title={localization.get('footer.privacy_policy')}
                />
                <FooterDocumentLink
                  requestRoute={`${process.env.REACT_APP_API_HOST}/documents/termsOfUse/download?locale=${localization.getLanguage()}`}
                  title={localization.get('footer.term_of_use')}
                />
              </MobileDiv>


              <div className="footer-logo">
              </div>

              <MobileUl className="nowrap">
                <li>
                  <Link to={"#"} onClick={(e) => {
                    e.preventDefault()
                    FreshChat.open()
                  }}>
                    <span className="link-footer">{localization.get("footer.support")}</span>
                  </Link>
                </li>
                {!this.props.noSocials &&
                  <li>
                    <Tooltip title="Instagram" placement="bottom">
                      <Link
                        className="footer-social-link"
                        target="_blank"
                        style={{top: 10}}
                        to="https://www.instagram.com/bloomclouds"
                      >
                        <Instagram/>
                      </Link>
                    </Tooltip>
                  </li>
                }
              </MobileUl>

              {/*<div style={{ width: "120px", float: "right", position: "relative" }}>
                <img style={{ width: "100%", marginTop: "3px" }} src={logo} alt="Logo flowlike" />
              </div>
              <div style={{ width: "80px", float: "right", position: "relative" }}>
                <h6>
                  <small>Powered by</small>
                </h6>
              </div>*/}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

const FooterDocumentLink = withStyles({
  title: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
})(({ classes, requestRoute, title }) => {
  return (
    <Link to={requestRoute} target="_blank">
      <h6 style={{ marginRight: 20 }}>
        <small className={classes.title}>
          {title}
        </small>
      </h6>
    </Link>
  );
});

export default withStyles(pagesStyle)(Footer);

const MobileDiv = styled.div`
display: inline-flex;
align-self: center;
  @media(max-width: 500px){
  justify-self: center;
  }
`;

const MobileUl = styled.ul`
margin: -5px;
place-self: end;
  @media(max-width: 500px){
  place-self: center;
  }
`;
